module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"HIRSCH Public Relations - Storytelling, Redaktion, Pressearbeit","short_name":"Hirsch PR","start_url":"/","background_color":"#fff","theme_color":"#D8222A","display":"minimal-ui","icon":"src/images/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"19a538411e2605325ce06b772cbf7ef1"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
